import cx from 'classnames';
import { Marker } from 'react-map-gl';
import * as GymsSearchStyles from './gyms-search-styles';
import { LocationMarkerSVG } from './location-marker';
import { SelectedLocationMarkerSvg } from './location-marker-selected';

export interface MarkerProps {
  offeringId: string;
  latitude: number;
  longitude: number;
  selectedOfferingId?: string;
  gymName?: string;
  handleMarkupClicked: (offeringId: string, event: any) => void;
  isDesktop?: boolean;
}

export const GymSearchMarker = (props: MarkerProps) => {
  const {
    offeringId,
    latitude,
    longitude,
    selectedOfferingId,
    gymName,
    handleMarkupClicked,
    isDesktop,
  } = props;

  const isSelected = offeringId === selectedOfferingId;

  return (
    <GymsSearchStyles.Marker>
      <Marker
        latitude={latitude}
        longitude={longitude}
        className={cx({
          'focus-marker': isSelected,
        })}
      >
        <GymsSearchStyles.StyledMarkUpButton
          data-ui-element-name={gymName}
          onClick={(event) => {
            handleMarkupClicked(offeringId, event);
            if (isDesktop) {
              (
                document.getElementById(`facility-${offeringId}`) as any
              ).scrollIntoViewIfNeeded();
            }
          }}
        >
          {!isSelected ? (
            <LocationMarkerSVG width={25} height={34} />
          ) : (
            <SelectedLocationMarkerSvg width={26} height={34} />
          )}
        </GymsSearchStyles.StyledMarkUpButton>
      </Marker>
    </GymsSearchStyles.Marker>
  );
};
